import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { Table, Tooltip } from "reactstrap";
import moment from "moment";
import { getDateLabel, isNonJobTimeType } from "../helpers/utils";

const WORK_HOURS_COLORS = {
  PTO: "#FF0000",
  TRAINING: "#FFCC00",
};

const getWorkHoursColor = (dayData) => {
  if (!dayData) return undefined;
  const hasPto = dayData.PTO.reg > 0 || dayData.PTO.ot > 0;
  if (hasPto) return WORK_HOURS_COLORS.PTO;
  const hasTraining = dayData.TRAINING.reg > 0 || dayData.TRAINING.ot > 0;
  if (hasTraining) return WORK_HOURS_COLORS.TRAINING;
  return undefined;
};

const PayrollTable = ({
  data,
  rawData,
  monday,
  otherTimeTypes,
  shouldShowDoubleTime,
  tooltipOpen,
  onToggleTooltip,
  onSeeDateDetails,
  onSeeOtherDetails,
}) => (
  <Table className="mb-0">
    <thead className="small text-muted">
      <tr>
        <th className="border-top-0">Employee</th>
        {Array.from(Array(7).keys()).map((c, index) => (
          <th className="border-top-0" key={index}>
            {getDateLabel(monday, c)}
          </th>
        ))}
        <th className="border-top-0">Regular</th>
        <th className="border-top-0">Overtime</th>
        {shouldShowDoubleTime ? (
          <th className="border-top-0">Double Time</th>
        ) : null}
        <th className="border-top-0">Other</th>
        <th className="border-top-0">Total</th>
      </tr>
    </thead>
    <tbody>
      {data.length ? (
        data.map((entry, i) => {
          const otherValue = otherTimeTypes
            .filter((item) => isNonJobTimeType(item))
            .reduce((p, c) => p + parseFloat(entry[c] || 0), 0);
          const isCaliforniaPayroll = rawData.some(
            (employee) =>
              employee.id === entry.employeeId &&
              employee.payRoll.some(
                (payrollEntry) => payrollEntry.IS_CALIFORNIA_PAYROLL
              )
          );
          return (
            <tr className="border-bottom" key={i}>
              <td className="text-truncate">
                {entry.total === entry.totalApproved && entry.approvedBy ? (
                  <>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className="mr-2"
                      size="sm"
                      color={"green"}
                      id={`TooltipApprovedStatus-${i}`}
                      onMouseEnter={() => onToggleTooltip(i)}
                      onMouseLeave={() => onToggleTooltip(null)}
                      onClick={() => onToggleTooltip(i)}
                    />
                    <Tooltip
                      isOpen={tooltipOpen === i}
                      target={`TooltipApprovedStatus-${i}`}
                      toggle={() => onToggleTooltip(null)}
                    >
                      Approved Time: {entry.totalApproved}
                      <br />
                      Approved By: {entry.approvedBy}
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className="mr-2"
                      size="sm"
                      color={"red"}
                    />
                  </>
                )}
                {entry.employee}
              </td>
              {Array.from(Array(7).keys()).map((c, i) => {
                const date = getDateLabel(monday, c);
                const value = entry[date];

                const employeeData = rawData.find(
                  (emp) => emp.id === entry.employeeId
                );
                const dateStr = moment(monday)
                  .add(c, "day")
                  .format("YYYY-MM-DD");
                const dayData = employeeData?.payRoll.find(
                  (pr) => pr.date === dateStr
                );
                const hoursColor = getWorkHoursColor(dayData);

                return (
                  <td
                    className={`border-top-0 ${
                      value !== "-" ? "text-link cursor-pointer" : ""
                    }`}
                    style={{ color: hoursColor }}
                    onClick={() =>
                      value !== "-"
                        ? onSeeDateDetails(entry, moment(monday).add(c, "day"))
                        : null
                    }
                    key={i}
                  >
                    {value}
                  </td>
                );
              })}
              <td className="text-truncate">{entry.regular}</td>
              <td className="text-truncate">{entry.overtime}</td>
              {shouldShowDoubleTime ? (
                <td className="text-truncate">
                  {isCaliforniaPayroll ? entry.double : "-"}
                </td>
              ) : null}
              <td
                className={`border-top-0 ${
                  otherValue > 0 ? "text-link cursor-pointer" : ""
                }`}
                onClick={() =>
                  otherValue > 0
                    ? onSeeOtherDetails(entry, isCaliforniaPayroll)
                    : null
                }
              >
                {otherValue.toFixed(2)}
              </td>
              <td className="text-truncate">{entry.total}</td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={13} className="text-center text-muted small">
            No data has been recorded
          </td>
        </tr>
      )}
    </tbody>
  </Table>
);

export default PayrollTable;
